import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { ModalTitle } from 'app/common/modals'
import { H4, H6, Text } from 'app/common/typography'
import { media, style } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { CircleMap } from 'app/assets/icons'
import Modal from 'react-modal'

const { text } = colors

type Props = {
    isOpen: boolean,
    mobile: boolean,
    description?: string,
    restaurants: Array<string>,
    handleClose: () => void
}

const LegalMentionsModal = (props: Props) => {
    const { isOpen, mobile, handleClose, description, restaurants } = props
    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            shouldCloseOnOverlayClick
            onRequestClose={handleClose}
            style={
                mobile ? style.classicModalMobileStyle : style.classicModalStyle
            }>
            <Container>
                <ModalTitle
                    center
                    handleClose={handleClose}
                    titleNode={
                        <FormattedMessage id="legal.notice">
                            {(label: string) => <StyledH4>{label}</StyledH4>}
                        </FormattedMessage>
                    }
                />
                <Description>
                    <Text>{description}</Text>
                    {restaurants.length > 1 && (
                        <Fragment>
                            <RestaurantLabel>
                                <CircleMap color={text} />
                                <FormattedMessage id="kingdom.privileges.coupon.modal.restaurants">
                                    {(label: string) => (
                                        <StyledH6>{label}</StyledH6>
                                    )}
                                </FormattedMessage>
                            </RestaurantLabel>
                            {restaurants.map(
                                (restaurant: string, index: number) => (
                                    <Restaurant key={index}>
                                        <Text>{restaurant}</Text>
                                    </Restaurant>
                                )
                            )}
                        </Fragment>
                    )}
                </Description>
            </Container>
        </Modal>
    )
}

const Container = styled.div`
    padding: 20px;
    ${media.medium`
        padding: 40px;
        margin: auto;
    `};
`

const Description = styled.div`
    overflow: auto;
    margin-top: 20px;
    min-height: 500px;
    ${media.medium`
        max-height: 500px;
    `};
`

const StyledH4 = styled(H4)`
    text-align: center;
`

const Restaurant = styled.p`
    margin: 0 0 0 30px;
`

const RestaurantLabel = styled.div`
    display: flex;
    justify-content: flex-start;
    margin: 30px 0 10px;
    align-items: center;
`

const StyledH6 = styled(H6)`
    margin-left: 5px;
`

export { LegalMentionsModal }
